import styled, { css } from 'styled-components';
import ButtonComponent from '@prisjakt/ui-button';
import { media, remCalc, layout } from '@prisjakt/ui-base';
import TooltipComponent from '@prisjakt/ui-tooltip-new';
import DropdownItemComponent from '@prisjakt/ui-dropdown-new/src/item';
import { actionButton } from '../../../../constants';

import { ButtonStyle } from '.';

const marginBottom = layout.spacing.xSmall;

type ActionButtonProps = {
  buttonStyle: ButtonStyle;
};
export const ActionButton = styled.div<ActionButtonProps>`
  flex: 0 0 32%;

  ${media.smallOnly`
    margin-bottom: ${marginBottom};
  `}

  ${props =>
    props.buttonStyle === 'circle' &&
    css`
      flex: none;
    `}
`;

type ButtonProps = {
  buttonStyle: ButtonStyle;
};
export const Button = styled(ButtonComponent)<ButtonProps>`
  margin: 0;
  padding: 8px 4px 8px 8px;
  overflow: hidden;
  width: 100%;
  ${p =>
    p.buttonStyle === 'circle' &&
    css`
      padding: 0;
      width: ${remCalc(50)};
      height: ${remCalc(50)};
      margin-right: ${remCalc(10)};
    `}
`;

export const Tooltip = styled(TooltipComponent).attrs({ minWidth: '180px' })`
  z-index: 5; /* Needs to be higher than Tabs (3) and Dropdown content (4) */
`;

type ProductActionButtons = {
  horizontal?: Boolean;
  buttonStyle?: ButtonStyle;
};
export const ProductActionButtons = styled.div<ProductActionButtons>`
  height: 100%;
  position: relative;
  display: flex;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(3, 32%);
  grid-column-gap: ${actionButton.buttonMarginMobile};
  
  ${media.mediumUp`
    margin-bottom: ${marginBottom};
  `}

  ${props =>
    !props.horizontal &&
    css`
      flex-direction: column;
      grid-template-columns: ${actionButton.buttonWidthVal}px;
    `}

  ${props =>
    props.buttonStyle === 'circle' &&
    css`
      display: flex;
      justify-content: flex-start;
    `}
`;

export const ButtonText = styled.div.attrs({ 'data-test': 'ButtonText' })`
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${media.mediumDown`
    display: none;
  `}
`;

export const DropdownItem = styled(DropdownItemComponent)`
  max-width: 150px;
`;
